import { createApp } from 'vue'
import App from './App.vue'

import Vue3Progress from 'vue3-progress'
const options = {
    position: "fixed",
    height: "3px",
    color: "#758585",
 };

import '@/assets/styles/main.css'

createApp(App).use(Vue3Progress, options).mount('#app')